import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SUPPORTED_CURRENCIES, useCurrency, type Currency } from '@/contexts/CurrencyContext';
import { useLanguage } from '@/contexts/LanguageContext';

const CurrencySwitcher = () => {
  const { currency, setCurrency } = useCurrency();
  const { isRTL } = useLanguage();

  return (
    <Select value={currency} onValueChange={(v) => setCurrency(v as Currency)}>
      <SelectTrigger
        className="h-9 w-[84px] text-xs"
        aria-label={isRTL ? 'العملة' : 'Currency'}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_CURRENCIES.map((c) => (
          <SelectItem key={c} value={c} className="text-xs">
            {c}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySwitcher;
